import script from "./DeclineView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeclineView.vue?vue&type=script&lang=ts&setup=true"

import "./DeclineView.vue?vue&type=style&index=0&id=afaf171e&lang=scss"
import "./DeclineView.vue?vue&type=style&index=1&id=afaf171e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afaf171e"]])

export default __exports__